const filterExamList = (
  examList,
  searchTerm,
  isHideCompletedChecked,
  isHideIncompleteChecked
) => {
  let filteredExamList = [];

  // Filter by search term
  if (searchTerm.length > 0) {
    examList.forEach((examValue) => {
      if (
        examValue.ExamTitle.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        filteredExamList.push(examValue);
      } else {
        let sectionFound = false;
        examValue.sections.forEach((section) => {
          if (
            section.sectionTitle
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
          ) {
            sectionFound = true;
          }
        });
        if (sectionFound) {
          filteredExamList.push(examValue);
        }
      }
    });
  } else {
    filteredExamList = examList;
  }

  // Filter by completed/incomplete
  let tempExamList = [];
  if (isHideCompletedChecked || isHideIncompleteChecked) {
    filteredExamList.forEach((examValue) => {
      if (isHideCompletedChecked && examValue.Completed) {
        // Do nothing
      } else if (isHideIncompleteChecked && !examValue.Completed) {
        // Do nothing
      } else {
        tempExamList.push(examValue);
      }
    });
  } else {
    tempExamList = filteredExamList;
  }

  return tempExamList;
};

export default filterExamList;
